/**
 * @author Pooja Waradkar
 *
 * @description:
 * Garfield Tags mapping table. Key value represent the variable name which needs
 * to be send in event object. In case if variable name and this tag table is mismatched
 * then the value will get dropped so be careful.
 * In case if you create a new tag the mapping should add here with a valid variable name.
 *
 * @returns object
 */

const tags = {
	api_method: 0, // Global tag for API method
	business_category: 1, // Global tag for business category
	channel_type: 2,
	instrument_type: 3,
	status_type: 4,
	search_by: 5,
	custom_column: 6,
	payment_mode: 7,
	date_type: 8,
	business_unit_type: 9, // Global tag for business unit type
	user_role: 10, // Global tag for user role
	navigation_type: 11, // Global tag for Navigation type, used in web-vitals
	utm_source: 12, // Global tag for utm source
} as const;

export default tags;
